import React from 'react';
import Authenticated from "../../libs/Authenticated";

class Echo extends React.Component {
    constructor(props) {
        super(props);
        this.authenticatedRef = React.createRef();
        // console.log(this.authenticatedRef.current.allowed);
    }

    render() {
        return <div>
            <h1>Echo</h1>
            <Authenticated passThrough ref={this.authenticatedRef}>
                {auth => auth ? (
                    <b>passThrough auth</b>
                ) : (
                    <b>passThrough !auth</b>
                )}
            </Authenticated>
            <hr/>
            <Authenticated>
                <b>auth</b>
            </Authenticated>
            <Authenticated not>
                <b>!auth</b>
            </Authenticated>
        </div>
    }
}

export default Echo;